import { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TelegramIcon from "@mui/icons-material/Telegram";
import { Link, Modal } from "@mui/material";
import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import board from "../../assets/images/board.png";
import student from "../../assets/images/student.png";
import Label from "../../component/Label";
import SearchInput from "../../component/SearchInput";
import Toaster from "../../component/Toaster";
import TypographyLabel from "../../component/Typography";
import { dashboardAction } from "../../store/dashboard/dashboardSlice";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import GlobalLoader from "../../component/GlobalLoader";
import { ReportService } from "../../store/report/ReportSlice";
import { CommonUtil } from "../../util/Utils";
import TooltipText from "@mui/material/Tooltip";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "400px",
  bgcolor: "#fff",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
  zIndex: 999999999,
  overflowY: "auto",
  height: "650px",
};

export default function Birthday() {
  const { t } = useTranslation();
  const [openList, setOpenList] = useState(false);
  const [birthdayData, setBirthdayData] = useState<any>();
  const [searchQuery, setSearchQuery] = useState("");
  const [allData, setAllData] = useState<any>(null);
  const dispatch = useDispatch<any>();
  const handleBirthdayListOpen = (i: any) => {
    setOpenList(true);
  };
  const handleBirthdayListClose = () => {
    setSearchQuery("");
    setOpenList(false);
  };
  const [spinner, setSpinner] = useState<boolean>(false);

  const getBirthdayData = () => {
    dispatch(dashboardAction({ apiAction: "dashboardBirthDay" }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setBirthdayData(result?.payload?.data?.data);
          setAllData(result?.payload?.data?.data);
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        // This console for debug the app if any error occurred in DEV
        console.log(err);
      });
  };

  const todaysBirthday = [
    ...((birthdayData && birthdayData["Student Todays Birthday"]) || []),
    ...((birthdayData && birthdayData["Instructor Todays Birthday"]) || []),
  ]
    .slice(0, 5)
    .map((name) => {
      if (
        birthdayData &&
        birthdayData["Student Todays Birthday"]?.includes(name)
      ) {
        return { name, type: "Student" };
      } else if (
        birthdayData &&
        birthdayData["Instructor Todays Birthday"]?.includes(name)
      ) {
        return { name, type: "Instructor" };
      } else {
        return { name, type: "Unknown" }; // if name is neither in Student nor in Instructor
      }
    });

  const handleSearch = () => {
    const result: any = {};

    // Loop through each key in the data object
    for (const key in allData) {
      // Check if the key contains the search query
      if (key.toLowerCase().includes(searchQuery.toLowerCase())) {
        result[key] = allData[key];
      } else {
        // If the key doesn't match, check each value in the array
        const filteredValues = allData[key].filter((value: any) =>
          value.toLowerCase().includes(searchQuery.toLowerCase())
        );

        // If there are matching values, add them to the result
        if (filteredValues.length > 0) {
          result[key] = filteredValues;
        }
      }
    }

    setBirthdayData(result);
  };

  const getReport = (values: any) => {
    setSpinner(true);
    dispatch(
      ReportService({
        apiAction: "studentBirthdayReport",
      })
    )
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          CommonUtil.download(result?.payload);
        }
      })
      .catch((err: any) => {
        setSpinner(false);
        console.log(err); //This console for debug the app if any error occurred in DEV
      })
      .finally(() => {
        setSpinner(false);
      });
  };

  const handlesendSMS = (id?: any, messageType?: string) => {
    setSpinner(true);
    dispatch(
      dashboardAction({
        apiAction: "sendBirthdaySMS",
        id: id,
        messageType: messageType 
      })
    )
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          Toaster.success(undefined, result?.payload?.data?.message);
        } 
        else {
          Toaster.error(undefined, result?.payload?.data?.errors);
        }
      })
      .catch((e: any) => {
        console.log(e);
      })
      .finally(() => {
        setSpinner(false);
      });
  };

  const handleGetReport = () => {
    getReport({});
  };

  useEffect(() => {
    handleSearch();
  }, [searchQuery]);

  useEffect(() => {
    getBirthdayData();
  }, []);

  return (
    <div className="text-dark paddong-y-10 padding-x-10">
      <GlobalLoader loading={spinner} />
      <div className="flex justify-content-between dashboard-heading padding-y-10 ">
        <div className="font-14 bolder">{t("birthday")}</div>
        <TooltipText
          title={t("downloadCurrentMonthStudenList")}
          placement="left"
        >
          <div className="font-14 bolder" onClick={handleGetReport}>
            <DownloadForOfflineIcon
              style={{ color: "#f48220", cursor: "pointer" }}
            ></DownloadForOfflineIcon>
          </div>
        </TooltipText>
        <Link className="viewall" onClick={handleBirthdayListOpen}>
          {t("viewAll")}
        </Link>
      </div>
      <div className="padding-y-10">
        <TypographyLabel title={t("today")} />
      </div>

      {todaysBirthday &&
        todaysBirthday?.length > 0 &&
        todaysBirthday?.map((item: any) => (
          <div className="flex" key={item?.name}>
            <div className="margin-right-10">
              <img
                src={item.type === "Student" ? student : board}
                width="20px"
                alt="student"
              />
            </div>
            <TypographyLabel title={item?.name[1]} />
          </div>
        ))}

      <Modal
        open={openList}
        onClose={handleBirthdayListClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="birthday-modal"
      >
        <Box sx={style} className="custom-scrollbar">
          <div className="padding-x-10 padding-y-10">
            <div
              className="flex dashboard-heading"
              onClick={handleBirthdayListClose}
            >
              <ArrowBackIcon /> <Label title={t("allBirthdays")} />
            </div>
            <div className="padding-y-20">
              <SearchInput
                handleChange={(e: any) => setSearchQuery(e.target.value)}
                placeholder={t("search")}
              />
            </div>
          </div>
          <div>
            <div className="mainBox2 padding-20">
              <div className="flex justify-content-between dashboard-heading padding-y-10 ">
                <Label title={t("todaysBirthday")} />
              </div>
              {birthdayData &&
                birthdayData["Student Todays Birthday"] &&
                birthdayData["Student Todays Birthday"]?.length > 0 &&
                birthdayData["Student Todays Birthday"]?.map((item: any) => (
                  <div className="flex justify-content-between padding-y-5">
                    <div className="flex">
                      <div className="margin-right-10">
                        <img src={student} width="20px" alt="student" />
                      </div>
                      <TypographyLabel title={item[1]} />
                    </div>
                    <div className="telegram-box">
                      <TelegramIcon 
                        onClick={() => handlesendSMS(item[0],"S")}
                       />
                    </div>
                  </div>
                ))}
              {birthdayData &&
                birthdayData["Instructor Todays Birthday"] &&
                birthdayData["Instructor Todays Birthday"]?.length > 0 &&
                birthdayData["Instructor Todays Birthday"]?.map((item: any) => (
                  <div className="flex justify-content-between padding-y-5">
                    <div className="flex">
                      <div className="margin-right-10">
                        <img src={board} width="20px" alt="student" />
                      </div>
                      <TypographyLabel title={item[1]} />
                    </div>
                    <div className="telegram-box">
                      <TelegramIcon 
                        onClick={() => handlesendSMS(item[0],"CI")}
                        />
                    </div>
                  </div>
                ))}
            </div>

            <div className="mainBox2 padding-20">
              <div className="flex justify-content-between dashboard-heading padding-y-10 ">
                <Label title={t("recentBirthday")} />
              </div>
              {birthdayData &&
                birthdayData["Student Recent Birthday"] &&
                birthdayData["Student Recent Birthday"]?.length > 0 &&
                birthdayData["Student Recent Birthday"]?.map((item: any) => (
                  <div className="flex justify-content-between padding-y-5">
                    <div className="flex">
                      <div className="margin-right-10">
                        <img src={student} width="20px" alt="student" />
                      </div>
                      <TypographyLabel title={item[1]} />
                    </div>
                    <div className="telegram-box">
                      <TelegramIcon 
                        onClick={() => handlesendSMS(item[0],"S")}
                        />
                    </div>
                  </div>
                ))}
              {birthdayData &&
                birthdayData["Instructor Recent Birthday"] &&
                birthdayData["Instructor Recent Birthday"]?.length > 0 &&
                birthdayData["Instructor Recent Birthday"]?.map((item: any) => (
                  <div className="flex justify-content-between padding-y-5">
                    <div className="flex">
                      <div className="margin-right-10">
                        <img src={board} width="20px" alt="student" />
                      </div>
                      <TypographyLabel title={item[1]} />
                    </div>
                    <div className="telegram-box">
                      <TelegramIcon 
                        onClick={() => handlesendSMS(item[0],"CI")}
                        />
                    </div>
                  </div>
                ))}
            </div>

            <div className="mainBox2 padding-20">
              <div className="flex justify-content-between dashboard-heading padding-y-10 ">
                <Label title={t("upcomingBirthday")} />
              </div>
              {birthdayData &&
                birthdayData["Student Upcoming Birthday"] &&
                birthdayData["Student Upcoming Birthday"]?.length > 0 &&
                birthdayData["Student Upcoming Birthday"]?.map((item: any) => (
                  <div className="flex justify-content-between padding-y-5">
                    <div className="flex">
                      <div className="margin-right-10">
                        <img src={student} width="20px" alt="student" />
                      </div>
                      <TypographyLabel title={item[1]} />
                    </div>
                    <div className="telegram-box">
                      <TelegramIcon 
                        onClick={() => handlesendSMS(item[0],"S")}
                        />
                    </div>
                  </div>
                ))}
              {birthdayData &&
                birthdayData["Instructor Upcoming Birthday"] &&
                birthdayData["Instructor Upcoming Birthday"]?.length > 0 &&
                birthdayData["Instructor Upcoming Birthday"]?.map(
                  (item: any) => (
                    <div className="flex justify-content-between padding-y-5">
                      <div className="flex">
                        <div className="margin-right-10">
                          <img src={board} width="20px" alt="student" />
                        </div>
                        <TypographyLabel title={item[1]} />
                        </div>
                      <div className="telegram-box">
                        <TelegramIcon 
                        onClick={() => handlesendSMS(item[0],"CI")}
                        />
                      </div>
                    </div>
                  )
                )}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
